import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatApprovalType(type) {
  const statusMap = findAllValues('request_approval_type') || {};
  return _get(statusMap, type, '');
}
